import React, { useEffect, useState } from "react";
import clsx from "clsx";

import {
  getOperationHistories,
  OperationHistory,
} from "api/operationHistories";

import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMoreOutlined";
import {
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
} from "@material-ui/core";
import MaybeLoading from "utils/MaybeLoading";
import { RESPONSE_STATUS_VALUES, OPERATION_TYPE } from "const";
import styles from "styles/admin-detail.module.scss";
import { convertDateSeparator } from "utils/utils";

interface Props {
  applyId: string;
}

const OperationHistoriesInformation = (props: Props) => {
  const { applyId } = props;

  const [histories, setHistories] = useState<OperationHistory[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const getOperationHistory = async () => {
      setLoading(true);
      const response = await getOperationHistories(`${applyId}`);
      setHistories(response);
      setLoading(false);
    };

    if (isOpen) {
      getOperationHistory();
    }
  }, [isOpen, applyId]);

  const toggleAccordionHandler = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Accordion className={clsx(styles.item)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={clsx(styles["operation-history-color"])}
          onClick={toggleAccordionHandler}
        >
          更新履歴
        </AccordionSummary>
        <CardContent>
          <MaybeLoading
            loading={loading}
            progressComponent={
              <div className={clsx(styles["loadind-operation-histories-area"])}>
                <div
                  className={clsx(
                    styles.circularProgressContainer,
                    styles["loadind-operation-histories-area-inner"]
                  )}
                >
                  <CircularProgress />
                </div>
              </div>
            }
          >
            <Table>
              <colgroup>
                <col width="13%" />
                <col width="13%" />
                <col width="48%" />
                <col width="13%" />
              </colgroup>
              <TableHead>
                <TableRow>
                  <TableCell>更新日時</TableCell>
                  <TableCell>更新者</TableCell>
                  <TableCell>作業内容</TableCell>
                  <TableCell>ステータス</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {histories.map((history, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>{convertDateSeparator(history.updatedAt)}</TableCell>
                      <TableCell>{history.name}</TableCell>
                      <TableCell>
                        {OPERATION_TYPE[`${history.operationType}`] ?? history.operationType}
                      </TableCell>
                      <TableCell>
                        {RESPONSE_STATUS_VALUES[`${history.responseStatus}`]}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </MaybeLoading>
        </CardContent>
      </Accordion>
    </>
  );
};

export default OperationHistoriesInformation;
